import useGetNewspaperExpirationLanguageConfig from './useGetNewspaperExpirationLanguageConfig'
export default useGetNewspaperExpirationLanguageConfig
